import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import ProductAnalysis from "@/pages/ProductAnalysis";
import Compare from "@/pages/Compare";
import Favorites from "@/pages/Favorites";
import Scan from "@/pages/Scan";
import Ingredients from "@/pages/Ingredients";
import IngredientDetail from "@/pages/IngredientDetail";
import Categories from "@/pages/Categories";
import CategoryDetail from "@/pages/CategoryDetail";
import { About, Privacy, Trending, Terms, Disclaimer } from "@/pages/StaticPages";
import InstallPrompt from "@/components/InstallPrompt";
import Analytics from "@/components/Analytics";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App grain min-h-screen relative">
      <BrowserRouter>
        <Analytics />
        <Header />
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/product/:slug" element={<ProductAnalysis />} />
            <Route path="/compare" element={<Compare />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/scan" element={<Scan />} />
            <Route path="/ingredients" element={<Ingredients />} />
            <Route path="/ingredient/:slug" element={<IngredientDetail />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/category/:slug" element={<CategoryDetail />} />
            <Route path="/trending" element={<Trending />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
          </Routes>
        </main>
        <Footer />
        <InstallPrompt />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
